<!-- Do the CSS class change manually on disable since we're overriding default styles -->
<button
    type="button"
    mat-flat-button
    [class]="
        isDisabled()
            ? 'button-secondary-color.disabled'
            : 'button-secondary-color'
    "
    [disabled]="isDisabled()"
    (click)="onClick()"
>
    {{ buttonText }}
</button>
